import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/language';
import { getStrLang } from '../components/Translate';
import { sendEmail, getAceiteTermos, setAceiteTermos } from '../api/fastcoinService';
import { ModalTermos } from '../components/ModalTermos';
import { AppletTermos } from '../components/AppletTermos';
import { useHistory, useLocation } from 'react-router-dom';
import { getWithdrawl } from '../api/fastcoinService';
import Loading from '../assets/loading.gif';
import ReturnInfoWithdrawl from '../components/ReturnInfoWithdrawl';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Logo from "../assets/logo.png";
import $ from 'jquery';

const numUSD = new Intl.NumberFormat(
    "en-US"
)
const numBRL = new Intl.NumberFormat(
    "pt-BR", {
    style: "currency",
    currency: "BRL"
}
)
const numARG = new Intl.NumberFormat(
    "de-DE"
)

const WithdrawScreen = () => {
    const history = useHistory();
    const location = useLocation();
    let order_from = sessionStorage.getItem("country");
    const { lang, translate, orderFromRetirada, setOrderFromRetirada } = useLanguage();
    const [modal, setModal] = useState(false);
    const [termos, setTermos] = useState(false);
    const [showTermos, setShowTermos] = useState(true);
    const [doc, setDoc] = useState(false);
    const [loadingCheckterms, setLoadingCheckterms] = useState(true);
    const [infoApi, setInfoApi] = useState({
        ordem: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        //dt_criacao: <img src={Loading} alt={"loading"} width="15px" height="15px"/>,
        //dt_atualizacao: <img src={Loading} alt={"loading"} width="15px" height="15px"/>,
        status: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        //cliente: <img src={Loading} alt={"loading"} width="15px" height="15px"/>,
        //pais: <img src={Loading} alt={"loading"} width="15px" height="15px"/>,
        amount: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        conv_amount: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        rate: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        bank_name: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        bank_branch: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        account_no: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        account_type: <img src={Loading} alt={"loading"} width="15px" height="15px" />,
        rate_updated: <img src={Loading} alt={"loading"} width="15px" height="15px" />
    });
    const [mensagem, setMensagem] = useState({
        msg1: "",
        msg2: "",
        msg3: ""
    });


    useEffect(() => {
        console.log("começando")
        function validarTermos() {
            getAceiteTermos(sessionStorage.getItem("order_no"))
            .then(res => {
                //console.log(res);
                if (res[0] !== undefined) {
                    sessionStorage.setItem("showTermos_deposit", false);
                    setShowTermos(false);
                } else {
                    setShowTermos(true);
                }
            })
            .catch(err => {
                if(err.error.includes("Could not find")){
                    setShowTermos(true);
                    setLoadingCheckterms(false);
                }else{
                    console.log(err);
                    alert("Please talk with the administrator");
                }
            })
            .finally(() => {
                setLoadingCheckterms(false);
            })
        }
        if (orderFromRetirada !== "") {
            /*
            if (sessionStorage.getItem("showTermos_retirada") === 'false') {
                setShowTermos(false);
                setLoadingCheckterms(false);
            } else {
                //setShowTermos(true);
            }
            */
            validarTermos();
        }
    }, [orderFromRetirada]);

    //Mostrar modal ou não
    function toggle() {
        setModal(!modal);
    }

    const aceitetermos = (confirm = null) => {
        setTermos(!termos);
        if (confirm === true && doc === true) {
            sessionStorage.setItem("documento_cliente", document.getElementsByName("docNumber").item(0).value);
            toggle();
            sessionStorage.setItem("showTermos_retirada", "false");
            //setShowTermos(false);
        }
    }

    const mostrarInformacoesPgto = () => {
        sessionStorage.setItem("documento_cliente", document.getElementsByName("docNumber").item(0).value);
        sessionStorage.setItem("showTermos_retirada", "false");
        setShowTermos(false);
    }


    const changeDoc = (state) => {
        setDoc(state);
    }

    async function callSendEmail() {
        //Essa função do cloudflare é usa para pegar o IP do usuário e poder enviar junto com o e-mail de aceite de termos
        let ipNumber;
        await $.get('https://www.cloudflare.com/cdn-cgi/trace', function (data) {
            data = data.trim().split('\n').reduce(function (obj, pair) {
                pair = pair.split('=');
                return obj[pair[0]] = pair[1], obj;
            }, {});
            ipNumber = data.ip;
            let objData = {};
            objData.to = "termos@payeasy.tech";
            objData.subject = `Order ${sessionStorage.getItem("order_no")} - withdraw - Accepted terms`;
            objData.text = `<b>Os termos foram aceitos para a retirada!</b><br/><b>Origem: </b>${data.ip}<br/><b>Data: </b>${new Date()}<br/><b>Nome: </b>${sessionStorage.getItem("full_Name")}<br/><b>E-mail: </b>${sessionStorage.getItem("email")}`;

            sessionStorage.setItem("sendedMail", "true");
            sendEmail(objData);
        });
        setAceiteTermos(sessionStorage.getItem("order_no"), sessionStorage.getItem("documento_cliente"), ipNumber);
    };

    useEffect(() => {
        translate();
    }, [modal, translate, showTermos, loadingCheckterms]);


    useEffect(() => {
        /*
        if (sessionStorage.getItem("showTermos_retirada") === "false") {
            setShowTermos(false);
        } else {
            setShowTermos(true);
        }
        */
        if (sessionStorage.getItem("sendedMail") === null && sessionStorage.getItem("order_no") !== null && sessionStorage.getItem("showTermos_retirada") === "false") {
            callSendEmail();
        }
    });

    useEffect(() => {
        const getWithdrawlInfo = async () => {
            let param = sessionStorage.getItem("order_no");
            //console.log(param);
            if (param !== null) {
                let result = await getWithdrawl(param);
                if (result !== undefined && result.error === undefined) {

                    //Validando se é uma ordem diferente
                    if (sessionStorage.getItem("order_no") !== null && sessionStorage.getItem("order_no") !== result.order_no.toString()) {
                        sessionStorage.clear();
                        sessionStorage.clear();
                    }

                    //console.log(result);
                    let amount
                    let amountConverted
                    let rateConv
                    let statusIn
                    switch (result.country) {
                        case "BR":
                            amount = "$ " + numUSD.format(result.usd_amount)
                            amountConverted = numBRL.format(result.converted_amount)
                            rateConv = numBRL.format(result.rate_used)
                            break;
                        case "AR":
                            amount = "$ " + numUSD.format(result.usd_amount)
                            amountConverted = numARG.format(result.converted_amount)
                            rateConv = numARG.format(result.rate_used)
                            break;
                        case "CO":
                            amount = "$ " + numUSD.format(result.usd_amount)
                            amountConverted = "$ " + numUSD.format(result.converted_amount)
                            rateConv = "$ " + numUSD.format(result.rate_used)
                            break;
                        default:
                            break;
                    }
                    if (result.status === "created" ||
                        result.status === "paid" ||
                        result.status === "cancelled" ||
                        result.status === "refunded" ||
                        result.status === "finished") {
                        statusIn = getStrLang(lang.nameLang, result.status);
                    } else {
                        statusIn = result.status;
                    }
                    sessionStorage.setItem("order_no", result.order_no)
                    sessionStorage.setItem("full_Name", result.full_name);
                    sessionStorage.setItem("email", result.email);
                    setOrderFromRetirada(result.country.toLowerCase());
                    setInfoApi({
                        ordem: result.order_no,
                        //dt_criacao: formatDataAPI(result.createdAt),
                        //dt_atualizacao: formatDataAPI(result.updatedAt),
                        status: result.status,
                        //cliente: result.client_name,
                        //pais: result.country,
                        amount: amount,
                        conv_amount: amountConverted,
                        rate: rateConv,
                        bank_name: result.bank_name,
                        bank_branch: result.bank_branch,
                        account_no: result.account_no,
                        account_type: result.account_type,
                        rate_updated: result.rate_updated
                    })
                } else {
                    setMensagem({
                        msg1: getStrLang(lang.nameLang, "msg3"),
                        msg2: getStrLang(lang.nameLang, "ordem_information"),
                        msg3: ""
                    });
                    setInfoApi({
                        ordem: "not found",
                        //dt_criacao: formatDataAPI(result.createdAt),
                        //dt_atualizacao: formatDataAPI(result.updatedAt),
                        status: "-",
                        //cliente: result.client_name,
                        //pais: result.country,
                        amount: "-",
                        conv_amount: "-",
                        rate: "-",
                        bank_name: "-",
                        bank_branch: "-",
                        account_no: "-",
                        account_type: "-",
                        rate_updated: "-"
                    });
                    let country = sessionStorage.getItem("country");
                    let broker = sessionStorage.getItem("broker");
                    if(country === null || broker === null || param === null || country.length === 0 || broker.length === 0 || param.length === 0){
                        return (
                            <>
                                {history.push("/404", {country: country, broker: broker, order_no: param + " - nf", from: history.location.pathname})}
                            </>
                        )
                    }
                }
            }
        };
        let country = sessionStorage.getItem("country");
        let broker = sessionStorage.getItem("broker");
        let order_no = sessionStorage.getItem("order_no");
        if(country === null || broker === null || order_no === null || country.length === 0 || broker.length === 0 || order_no.length === 0){
            history.push("/404", {country: country, broker: broker, order_no: order_no, from: history.location.pathname})
        }else{
            getWithdrawlInfo();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
        <div>
            <Navbar />
            <div className="container-withdrawl">
                <div className="container-main-withdrawl boxes">
                    {showTermos === false ?
                        <>
                            <img src={Logo} alt={"Logo"} width="180px" height="60px" style={{ marginTop: "5px" }} />
                            <ReturnInfoWithdrawl infoApi={infoApi} mensagem={mensagem} />
                        </>
                        :
                        <>
                            {!loadingCheckterms ?
                                <AppletTermos
                                    aceitetermos={aceitetermos}
                                    toggle={toggle}
                                    lang={lang}
                                    getStrLang={getStrLang}
                                    termos={termos}
                                    mostrarInformacoesPgto={mostrarInformacoesPgto}
                                    orderFrom={order_from}
                                    dataLang={"op_saque"}
                                    doc={doc}
                                    changeDoc={changeDoc}
                                />
                                :
                                <div className="centered-loading-terms-withdrawl">
                                    <img src={Loading} alt={"loading"} width="30px" height="30px" />
                                </div>
                            }
                        </>
                    }
                </div>
                {modal &&
                    <ModalTermos
                        modal={modal}
                        toggle={toggle}
                        lang={lang}
                        getStrLang={getStrLang}
                        aceitetermos={aceitetermos}
                        doc={doc}
                    />
                }
            </div>
            <Footer />
        </div>
    )
}

export default WithdrawScreen